import { render, staticRenderFns } from "./kpi-brand-staff.vue?vue&type=template&id=6351f1e9&scoped=true"
import script from "./kpi-brand-staff.vue?vue&type=script&lang=js"
export * from "./kpi-brand-staff.vue?vue&type=script&lang=js"
import style0 from "./kpi-brand-staff.vue?vue&type=style&index=0&id=6351f1e9&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6351f1e9",
  null
  
)

export default component.exports